/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:06:06
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-21 14:57:22
 */
import req from "@/utils/request";

//  征集调查列表
export const findListPage = (params) => req.post("/interact-service/m/isCollect/findListPage", params);

// 删除数据
export const collectDelete = (params) => req.post("/interact-service/m/isCollect/delete", params);

// 修改显示状态
export const updateDisplayStatus = (params) => req.post("/interact-service/m/isCollect/updateDisplayStatus", params);

// 日志
export const findLogList = (params) => req.post("/interact-service/m/isCollectOperateLog/findLogList", params);

// 意见清单列表
export const opinionFindListPage = (params) => req.post("/interact-service/m/isCollectOpinion/findListPage", params);

// 征集详情数据
export const collectDetils = (params) => req.post("/interact-service/m/isCollect/id", params);

// 修改征集数据
export const updateCollect = (params) => req.post("/interact-service/m/isCollect/updateCollect", params);

// 新增征集数据
export const saveCollect = (params) => req.post("/interact-service/m/isCollect/saveCollect", params);

// 通过征集id查询反馈数据
export const collectFeedback = (params) => req.post("/interact-service/m/isCollectFeedback/findById", params);

// 通过征集id查询反馈数据
export const addCollectFeedback = (params) => req.post("/interact-service/m/isCollectFeedback/addCollectFeedback", params);

// 修改征集id查询反馈数据
export const updateCollectFeedback = (params) => req.post("/interact-service/m/isCollectFeedback/updateCollectFeedback", params);
export const IsCollectOpinionListExport = (params) => req.down("/interact-service/m/isCollectOpinion/IsCollectOpinionListExport", params);